import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconIntersectComponent } from "./med-icon-intersect.component";

@NgModule({
  declarations: [
    MedIconIntersectComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconIntersectComponent,
  ],
})
export class MedIconIntersectModule { }
